import { render } from "./AddRenew.vue?vue&type=template&id=67ec8adc&scoped=true"
import script from "./AddRenew.vue?vue&type=script&lang=js"
export * from "./AddRenew.vue?vue&type=script&lang=js"

import "./AddRenew.vue?vue&type=style&index=0&id=67ec8adc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67ec8adc"]])

export default __exports__